import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]
  static values = {
    open: Boolean
  }

  connect() {
    this.clickHandler = this.closeIfOutside.bind(this)
    document.addEventListener("click", this.clickHandler)

    this.addItemClickHandlers()
  }

  addItemClickHandlers() {
    document.querySelectorAll('[data-dropdown] a, [data-dropdown] button').forEach(item => {
      if (!item.hasAttribute('data-dropdown-ignore-close')) {
        item.addEventListener('click', (event) => {
          event.stopPropagation()
          const dropdown = item.closest('[data-dropdown]')
          if (dropdown) {
            dropdown.classList.add('hidden')
            this.toggleBackdrop(dropdown.getAttribute('data-dropdown-type'), "hide")
          }
        })
      }
    })
  }

  disconnect() {
    document.removeEventListener("click", this.clickHandler)
  }

  toggle(event) {
    event.stopPropagation()

    const dropdownId = event.currentTarget.getAttribute("data-dropdown-id")
    this.closeAllExcept(dropdownId)
    const dropdown = document.getElementById(dropdownId)
    dropdown.classList.toggle("hidden")
    
    this.toggleBackdrop(dropdown.getAttribute('data-dropdown-type'), "toggle")
  }

  closeAllExcept(dropdownId) {
    document.querySelectorAll('[data-dropdown]').forEach(dropdown => {
      if (dropdown.id !== dropdownId && !dropdown.classList.contains("hidden")) {
        dropdown.classList.add("hidden")
        this.toggleBackdrop(dropdown.getAttribute('data-dropdown-type'), "hide")
      }
    })
  }

  closeIfOutside(event) {
    if (event.target.closest('[data-controller="dropdown"]') !== null) {
      return
    }
    document.querySelectorAll('[data-dropdown]').forEach(dropdown => {
      if (!dropdown.classList.contains("hidden")) {
        dropdown.classList.add("hidden")
        this.toggleBackdrop(dropdown.getAttribute('data-dropdown-type'), "hide")
      }
    })

    document.querySelectorAll('.mobile-dropdown-content').forEach(dropdown => {
      if (!dropdown.classList.contains("hidden")) {
        dropdown.classList.add("hidden")
        const button = dropdown.previousElementSibling
        const icon = button.querySelector(".mobile-dropdown-icon")
        if (icon) {
          icon.classList.remove("transform")
          icon.classList.remove("rotate-180")
        }
      }
    })

  }

  toggleMobile(event) {
    const button = event.currentTarget
    const title = button.querySelector(".title")
    title.classList.toggle("text-xl")
    title.classList.toggle("font-bold")
    title.classList.toggle("font-tinos")
    const dropdownContent = button.nextElementSibling
    dropdownContent.classList.toggle("hidden")
    const icon = button.querySelector(".mobile-dropdown-icon")
    icon.classList.toggle("transform")
    icon.classList.toggle("rotate-180")
  }

  toggleMobileMenu() {
    const mobileMenu = document.getElementById("mobile-menu")
    mobileMenu.classList.toggle("hidden")
    const backdrop = document.getElementById("header-backdrop");
    backdrop.classList.toggle("hidden");
  }

  closeDropdown(dropdownId) {
    const dropdown = document.getElementById(dropdownId)
    if (dropdown && !dropdown.classList.contains("hidden")) {
      dropdown.classList.add("hidden")
    }
  }

  close(event) {
    const dropdownId = event.currentTarget.closest('[data-dropdown]').id;
    if(dropdownId) {
      this.closeDropdown(dropdownId);
      const backdrop = document.getElementById("header-backdrop");
      backdrop.classList.add("hidden");
    }
  }

  toggleBackdrop(dropdownType, action){
    if (dropdownType !== "destinations" && dropdownType !== "stays") {
      return
    }
    const backdrop = document.getElementById("header-backdrop");
    if(action === "hide") {
      backdrop.classList.add("hidden");
    } else if (action === "toggle") {
      backdrop.classList.toggle("hidden");
    } else if (action === "show") {
      backdrop.classList.remove("hidden");
    }
  }
}
